module.exports = function noop() {
  // nothing here
};



//////////////////
// WEBPACK FOOTER
// /node_modules/cmnjs/function/noop.js
// module id = 98
// module chunks = 0